/**
 * Copyright 2022 Design Barn Inc.
 */

import type { IPlayerProps } from '@lottiefiles/react-lottie-player';
import { Player } from '@lottiefiles/react-lottie-player';
import type { ReactElement } from 'react';
import React from 'react';

const UnMemofiedLottiePlayer = (props: IPlayerProps): ReactElement => {
  const { className, keepLastFrame = false, loop = true, src, style } = props;

  return <Player keepLastFrame={keepLastFrame} autoplay loop={loop} src={src} className={className} style={style} />;
};

export const LottiePlayer = React.memo(UnMemofiedLottiePlayer);
